import { render, staticRenderFns } from "./PageResult.vue?vue&type=template&id=11020a28&scoped=true"
import script from "./PageResult.vue?vue&type=script&lang=js"
export * from "./PageResult.vue?vue&type=script&lang=js"
import style0 from "./PageResult.vue?vue&type=style&index=0&id=11020a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11020a28",
  null
  
)

export default component.exports